/* eslint-disable global-require */

/* eslint-disable class-methods-use-this */
import {API_UI_CONFIG_URL, COMMON_HEADER_CONFIG} from "../config";

class CentralUIConfigService {
  getAccessToken = () => localStorage.getItem("accessToken");

  getListUserConfig = (list_permission) =>
    new Promise((resolve, reject) => {
      const axios = require("axios");
      const data = JSON.stringify({
        permission_ids: list_permission
      });

      const config = {
        method: "post",
        url: `${API_UI_CONFIG_URL}/ui-config/list-by-permission-ids`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            localStorage.setItem("listUIConfig", JSON.stringify(response.data.data));
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const centralUIConfigService = new CentralUIConfigService();

export default centralUIConfigService;
